// src/hooks/useChannelInfo.ts
import { useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import { getChannelInfo } from '../services/channelService';

/**
 * LINE公式アカウントのチャネル情報型
 */
export interface ChannelInfo {
  line_channel_id?: string;
  line_access_token?: string;
  line_channel_secret?: string;
}

/**
 * 公式アカウント向けの LINE チャネル情報を取得するフック
 */
export const useChannelInfo = () => {
  return useQuery<ChannelInfo, Error>({
    queryKey: ['channelInfo'],
    queryFn: async (): Promise<ChannelInfo> => {
      const res: AxiosResponse<ChannelInfo> = await getChannelInfo();
      return res.data;
    },
    staleTime: 5 * 60 * 1000, // 5分間はキャッシュを新鮮とみなす
    retry: 1, // エラー時に1回だけリトライ
    refetchOnWindowFocus: false, // フォーカス時の自動再フェッチを無効化
  });
};
